/*
 * Minimalistic version of the search dialog, that provides a ready-only view
 * to be used as a loading component in async components and SSR.
 */

import { SearchInputSkeleton, ThemeProvider } from '@atlassian/search-dialog/skeleton';
import React from 'react';
export const ProductSearchInputSkeleton = ({
  theme,
  ...rest
}) => {
  if (theme) {
    return /*#__PURE__*/React.createElement(ThemeProvider, {
      partialSearchCSS: theme
    }, /*#__PURE__*/React.createElement(SearchInputSkeleton, rest));
  } else {
    return /*#__PURE__*/React.createElement(SearchInputSkeleton, rest);
  }
};